
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const dirtyC: IProductData = {
  id: "popeaudio-dirtyc",
  name: "Dirty C Desktop",
  description: "Vintage analogue chorus based on the revered Roland RE-501",
  specialOrder: true,
  images: ["/img/popeaudio_dirtyC_front.png", "/img/popeaudio_dirtyC_back.png", "/img/popeaudio_dirtyC.jpg"],
  details: [{
    label: "Description",
    markdown: `
The Pope Audio Dirty-C authentically recreates the character and vibe of the iconic Roland RE-501 chorus effect whilst adding a host of useful features such as effect rate, depth control, mix blend and hi-Z instrument input.  
Three separate modulation modes – “Vibrato”, “RE501” and “Ring Mod” – offer slightly different variations of modulation; from subtle movement and character to more creative settings!  

Utilising an original BBD MN-3007 chip - the same chip used in the original RE-501 chorus - the Dirty-C perfectly replicates the lush, lo-fi sound of the original, albeit in a more convenient, affordable and reliable package.  
`
  }, {
    label: "Features",
    markdown: `
- Genuine Bucket Brigade MN-3007 chip as used in original RE-501 Chorus
- Fully analogue path
- Fully balanced I/O
- Optional hi-Z instrument input (unbalanced)
- Hand-built in the UK
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.popeaudio.co.uk/general-1-1" target="_blank">https://www.popeaudio.co.uk/general-1-1</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.FX, HASHTAGS.MIXING, HASHTAGS.RECORDING, HASHTAGS.ONE_U, HASHTAGS.RACK],
    manufacturer: BRAND.POPE_AUDIO,
  }
}